import { createFileRoute } from '@tanstack/react-router';
import { SigningRequestList } from '@features/signing-requests/SigningRequestList';
import { validateTableSearch } from '@utils/tabHelpers';

export const Route = createFileRoute('/t/signing-requests/')({
  validateSearch: (search: Record<string, unknown>) =>
    validateTableSearch(search, { sortBy: 'createdOn', sortDir: 'desc' }),
  component: TenantSigningRequestsPage,
});

function TenantSigningRequestsPage() {
  const searchParams = Route.useSearch();
  return (
    <SigningRequestList
      routeTo="/t/signing-requests"
      searchParams={searchParams}
    />
  );
}
